import { hydrateRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"

import { CacheProvider } from "@emotion/react"

import CssBaseline from "@mui/material/CssBaseline"

import { App } from "./App"
import createEmotionCache from "./createEmotionCache"
import window from "./lib/window"
import { createStore } from "./redux"

const cache = createEmotionCache()

const renderMethod = hydrateRoot

const serverState = window.preloadedReduxState
const store = createStore(serverState)

const root = document.getElementById("root")

if (!root) throw new Error("No root element found")

renderMethod(
  root,
  <BrowserRouter>
    <CacheProvider value={cache}>
      <CssBaseline />
      <Provider store={store} serverState={window.preloadedReduxState}>
        <App />
      </Provider>
    </CacheProvider>
  </BrowserRouter>,
)

import.meta.hot
  ? console.debug("Client entrypoint rendered react tree")
  : console.debug("Client entrypoint hydrated react tree")
